var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { useStyles } from "../assets/style";
import "../assets/style.css";
import { CollectAFY, ButtonAFY, variants, icons, sizes, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../../assets/themes/theme";
import { Title } from "../../../components/layout/style";
import { Container, } from "../assets/style";
var View = function (props) {
    var classes = useStyles();
    var _a = React.useState(props.products), products = _a[0], setProducts = _a[1];
    useEffect(function () {
        if (props.products && props.products.length > 0) {
            setProducts(props.products);
        }
    }, [props.products]);
    var onClickNext = function (e) {
        props.onClickNext && props.onClickNext(e);
    };
    var onClickBack = function (e) {
        props.onClickBack && props.onClickBack(e);
    };
    return (_jsxs(React.Fragment, { children: [_jsx(Container, { children: _jsx(ButtonAFY, { variant: variants.text, label: "Regresar", icon: icons.ArrowBackIosNew, size: sizes.small, color: themeCore.colors.primaryText, onClick: onClickBack }) }), _jsxs(Title, { children: [props.title, _jsx("span", __assign({ className: " status ".concat(props.status || '', " ") }, { children: props.estado }))] }), _jsx("div", __assign({ className: "containerPanel", style: { marginTop: "15px" } }, { children: _jsx(CollectAFY, { showResumen: true, backgroundColorBack: props.backgroundColorBack, backgroundColorNext: props.backgroundColorNext, next: props.next, estado: props.estado, onClickNext: onClickNext, onUploadFiles: props.onUploadFiles, onClickBack: onClickBack, readOnly: props.readOnly, details: props.details, collectionSummary: props.collectionSummary, billingResults: props.billingResults, uploadFiles: props.uploadFiles, uploadedResults: props.uploadedResults }) }))] }));
};
export default View;
